import { Clock, LinearToneMapping, LoadingManager, PMREMGenerator, WebGLRenderer } from "three";
import Stats from "three/examples/jsm/libs/stats.module";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { CameraController } from "../componets3D/CameraController";
import { sizedcanvasHome } from "../../helpers/Constnats";
import hdri from "../../assets/hdri/provence_studio_1k.hdr";
import { CharcterOxxo } from "./objects/CharacterOxxo";

import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import {
	MainScene,
	SceneTeam2Introducion,
	SceneTeam2TopicOne,
	SceneTeam2TopicTwo,
	SceneTeam2TopicThree,
} from "./scene";
import { sceneNumbers } from "./scene/typeScenes";
// import { GUI } from "dat.gui";
let deltasum = 0;
let interval = 1 / 60;

export class App {
	constructor(container, pointsTootltips) {
		this.container = container;
		this.loadingManager = new LoadingManager();
		this.clock = new Clock();
		this.renderer = new WebGLRenderer({ antialias: true, alpha: true });
		this.renderer.setPixelRatio(window.devicePixelRatio);
		//
		this.container.appendChild(this.renderer.domElement);
		this.camera = new CameraController(
			60,
			this.container.clientWidth / this.container.clientHeight,
			0.1,
			500,
			this.container,
			this.renderer.domElement
		);
		this.camera.position.set(-1.534, 226, 300);

		this.actualScene = 0;
		this.selectedCharacterIntroduction = {
			after: -1,
			before: -1
		}

		this.loadingHDRI();
		// * creacion de scenas para las actividades
		this.mainScene = new MainScene(this.container, this.loadingManager);
		//* team 2
		this.sceneTeam2Introduction = null;
		this.sceneTeam2TopicOne = null;
		this.sceneTeam2TopicTwo = null;
		this.sceneTeam2TopicThree = null;
		// model selected

		//
		this.stats = new Stats();
		this.stats.showPanel(0);
		this.stats.domElement.style.cssText = "position:absolute;bottom: 0;right:0px;";
		document.body.appendChild(this.stats.dom);
		//
		this.onResized();
		this.loadingProyectEvents();
		this.listenEmitters();
		window.addEventListener(
			"resize",
			() => {
				this.onResized();
				setTimeout(() => {
					this.onResized();
				}, 500);
			},
			{ passive: true }
		);
	}
	onLoadCharcater(callback) {
		if (this.characterSelected) {
			callback();
		} else {
			const loadingManagerCharacter = new LoadingManager();
			const idCharacter = parseInt(localStorage.getItem("character"));
			if (idCharacter) {
				this.characterSelected = new CharcterOxxo(loadingManagerCharacter, idCharacter, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
			} else {
				this.characterSelected = new CharcterOxxo(loadingManagerCharacter, 1, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
			}
			loadingManagerCharacter.onLoad = () => {
				callback();
			};
		}
	}

	onResized() {
		this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
		this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
		this.camera.updateProjectionMatrix();
	}

	loadingHDRI() {
		const loderhdr = new RGBELoader(this.loadingManager);
		loderhdr.load(hdri, (texture) => {
			const pmremGenerator = new PMREMGenerator(this.renderer);
			var envMap = pmremGenerator.fromEquirectangular(texture).texture;

			this.environmentToScenes = envMap;

			texture.dispose();
			pmremGenerator.dispose();
		});
		this.renderer.toneMapping = LinearToneMapping;
		this.renderer.toneMappingExposure = 0.58;
		// var gui = new GUI();
		// gui.add(this.renderer, "toneMappingExposure", 0, 2).step(0.01).name("Exposure");
	}

	loadingProyectEvents() {
		// this.loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
		// 	// console.log("Started loading file: " + url + ".\nLoaded " + itemsLoaded + " of " + itemsTotal + " files.");
		// };
		// this.loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
		// 	// const percentage = (itemsLoaded / itemsTotal) * 100;
		// };
		this.loadingManager.onLoad = () => {
			// loading complete
			this.mainScene.environment = this.environmentToScenes;
			ObserverEmitter.emit(EVENTS.loadingComplete);
			this.mainScene.SceneInitialState();
			this.render();
		};
	}

	animationToRescaleRenderer(scale = 0) {
		const data = {
			iniposition: window.innerWidth,
		};
		gsap.timeline().to(data, {
			duration: 0.3,
			iniposition: window.innerWidth - scale,
			onUpdate: () => {
				this.renderer.setSize(data.iniposition, this.container.clientHeight);
				this.camera.aspect = data.iniposition / this.container.clientHeight;
				this.camera.updateProjectionMatrix();
			},
		});
	}

	listenEmitters() {
		// * move to main menu
		ObserverEmitter.on(EVENTS.back_to_main, () => {
			if (this.actualScene !== 0) {
				this.actualScene = sceneNumbers.initMainMenu
				this.animationToRescaleRenderer(sizedcanvasHome);
				this.mainScene.moveMain()
			}
		});
		ObserverEmitter.on(EVENTS.init_mainMenu, () => {
			this.actualScene = sceneNumbers.initMainMenu;
			this.animationToRescaleRenderer(sizedcanvasHome);
			this.mainScene.SceneInitialState();
		});
		//* team 2
		//* Introduction
		ObserverEmitter.on(EVENTS.team2.introduction, (activity) => {
			this.loadingTeam2Introduction(() => {
				this.actualScene = sceneNumbers.team2SIntroduction;
				this.animationToRescaleRenderer();
				this.sceneTeam2Introduction.SceneInitialState();
				this.sceneTeam2Introduction.ActivitiSelected(activity);
			});
		});
		//* SubTopic 1
		ObserverEmitter.on(EVENTS.team2.subtopicOne.initScene, (activity) => {
			this.loadingTeam2TopicOne(() => {
				this.actualScene = sceneNumbers.team2SubtopicOne;
				this.animationToRescaleRenderer();
				this.sceneTeam2TopicOne.SceneInitialState();
				this.sceneTeam2TopicOne.ActivitiSelected(activity);
			});
		});
		//* SubTopic 2
		ObserverEmitter.on(EVENTS.team2.subtopicTwo.initScene, (activity) => {
			this.loadingTeam2TopicTwo(() => {
				this.actualScene = sceneNumbers.team2SubtopicTwo;
				this.animationToRescaleRenderer();
				this.sceneTeam2TopicTwo.SceneInitialState();
				this.sceneTeam2TopicTwo.ActivitiSelected(activity);
			});
		});
		//* SubTopic 3
		ObserverEmitter.on(EVENTS.team2.subtopicThree.initScene, (activity) => {
			this.loadingTeam2TopicThree(() => {
				this.actualScene = sceneNumbers.team2SubtopicThree;
				this.animationToRescaleRenderer();
				this.sceneTeam2TopicThree.SceneInitialState();
				this.sceneTeam2TopicThree.ActivitiSelected(activity);
			});
		});
	}

	loadingTeam2Introduction(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTeam2Introduction) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTeam2Introduction = new SceneTeam2Introducion(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTeam2TopicOne(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTeam2TopicOne) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTeam2TopicOne = new SceneTeam2TopicOne(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTeam2TopicTwo(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTeam2TopicTwo) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTeam2TopicTwo = new SceneTeam2TopicTwo(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTeam2TopicThree(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTeam2TopicThree) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTeam2TopicThree = new SceneTeam2TopicThree(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	render() {
		const delta = this.clock.getDelta();
		deltasum += delta;

		// requestAnimationFrame(this.render);
		if (deltasum > interval) {
			let sceneToRender;

			switch (this.actualScene) {
				case sceneNumbers.initMainMenu:
					sceneToRender = this.mainScene;
					break;
				case sceneNumbers.team2SIntroduction:
					sceneToRender = this.sceneTeam2Introduction;
					break;
				case sceneNumbers.team2SubtopicOne:
					sceneToRender = this.sceneTeam2TopicOne;
					break;
				case sceneNumbers.team2SubtopicTwo:
					sceneToRender = this.sceneTeam2TopicTwo;
					break;
				case sceneNumbers.team2SubtopicThree:
					sceneToRender = this.sceneTeam2TopicThree;
					break;
				default:
					sceneToRender = this.mainScene;
					break;
			}

			this.renderer.render(sceneToRender, this.camera);
			sceneToRender.renderAnimations(deltasum);
			this.camera.update(deltasum);

			if (this.characterSelected) {
				// this.characterSelected.renderAnimations(deltasum, this.camera);
				this.characterSelected.renderAnimations(deltasum, null);
			}

			this.stats.update();

			deltasum = deltasum % interval;
		}
		requestAnimationFrame(() => this.render());
	}
}
